<ng-container *ngIf="!item.hidden">
  <div class="group-title">
    <span
      class="hint-text"
      [translate]="item.translate"
    >{{ item.title }}</span>
  </div>
  <div class="group-items">
    <ng-container *ngFor="let item of item.children">
      <app-nav-vertical-group
        *ngIf="item.type==='group'"
        [item]="item"
      ></app-nav-vertical-group>
      <app-nav-vertical-collapse
        *ngIf="item.type==='collapse'"
        [item]="item"
      ></app-nav-vertical-collapse>
      <app-nav-vertical-item
        *ngIf="item.type==='item'"
        [item]="item"
      ></app-nav-vertical-item>
    </ng-container>
  </div>
</ng-container>
